<template>
  <div class="bg-color">
    <div class="container py-5">
      <div class="row m-0">
        <div class="col-12 col-md-7">
          <h2 class="text-primary mb-4">
            {{ $t('whyEM.title') }}
          </h2>
          <ul class="style-type-none" v-html="$t('whyEM.content')">
          </ul>

          <p v-html="$t('whyEM.cta')">
          </p>

          <router-link class='' to='/contact'>{{ $t('whyEM.ctaButton') }}</router-link>
        </div> 
      </div>
    </div>
  </div>
</template>

<style scoped>
h2 { font-size: 1.8em; }

.bg-color {
  background-color: #F4F3F9;
}

ul.style-type-none {
  list-style-type: none;
}
</style>